/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Preview_LinkInputs */

const cs_settings_office_preview_link = /** @type {(inputs: Settings_Office_Preview_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled veřejného webu`)
};

const en_settings_office_preview_link = /** @type {(inputs: Settings_Office_Preview_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview public website`)
};

/**
* | output |
* | --- |
* | "Preview public website" |
*
* @param {Settings_Office_Preview_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_preview_link = /** @type {((inputs?: Settings_Office_Preview_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Preview_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_preview_link(inputs)
	return cs_settings_office_preview_link(inputs)
});